<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="form">
            <div
                v-if="(getIsBusinessProcess && getBrokerageData.contract_id && getBrokerageData.pdf && getCurrentUser.type === 'user') || !getIsBusinessProcess">
                <component :is="thisComponent" ref="dataComponent" @success="isDisabled = false" :no-statements="getIsBusinessProcess" :privacy-required="getIsBusinessProcess ? !getIsSimpleRegistration : false"/>
                <div class="con-1334 navBtn">
                    <LoadingButton
                        :text=" getIsBusinessProcess ? 'Szerződés aláírása' : 'Megkötöm'"
                        class="navBtn-next btn btn-blue"
                        @click="handleNext"
                        :loading="loading"
                    />
                </div>
            </div>
            <div class="error_text" v-if="getIsBusinessProcess && (!getBrokerageData.contract_id || !getBrokerageData.pdf || getCurrentUser.type !== 'user')">
                Nem található szerződés. Ide kell szöveg.
            </div>
        </div>
        <div class="con-1334 box-white mt-30px accordion-view" v-if="getIsBusinessProcess && getCurrentUser.type === 'user'">
            <Accordion
                v-for="(accordion, index) in getContractSummary"
                :key="index"
                :title="accordion.title"
                :baseShow="accordion.open"
                :class="accordion.class"
            >
                <ul>
                    <li
                        v-for="(item, index) in accordion.items"
                        :key="index"
                        :style="{ width: item.title === undefined ? '100%' : '33%' }"
                    >
                        <span v-if="item.title">{{ item.title }}:</span>
                        <span :class="{ 'font-italic': item.value === null }">
							{{ item.value === null ? ' - ' : item.value }}
						</span>
                    </li>
                </ul>
                <div class="d-flex flex-column items-center" v-if="accordion.items.length === 0">
					<span class="d-block mt-12px">
						Nincs megjeleníthető adat.
					</span>
                </div>
            </Accordion>
        </div>
    </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import contractingRouter from '@/mixins/contractingRouter';
import GranitStatement from '@/pages/Contracting/Granit/Statement';
import ColonnadeStatement from '@/pages/Contracting/Colonnade/Statement';
import KobeStatement from '@/pages/Contracting/Kobe/Statement';
import UnionStatement from '@/pages/Contracting/Union/Statement';
import AllianzStatement from '@/pages/Contracting/Allianz/Statement';
import GeneraliStatement from '@/pages/Contracting/Generali/Statement';
import AlfaStatement from '@/pages/Contracting/Alfa/Statement';
import LoadingButton from '@/components/elements/LoadingButton';
import Accordion from "@/components/Accordion.vue";

export default {
    mixins: [contractingRouter],
    data() {
        return {
            loading: false,
        };
    },
    components: {
        Accordion,
        LoadingButton,
        GranitStatement,
        ColonnadeStatement,
        KobeStatement,
        UnionStatement,
        AllianzStatement,
        AlfaStatement,
        GeneraliStatement,
    },
    computed: {
        ...mapGetters('contracting', ['getSelectedInsurerCode', 'getInsurerCodes', 'getCheckboxData', "getBrokerageData","getContractSummary"]),
        ...mapGetters(['getIsBusinessProcess']),
        ...mapGetters(['getCalculation']),
        ...mapGetters('auth', ['getIsSimpleRegistration','getCurrentUser']),
        thisComponent() {
            if (this.getSelectedInsurerCode !== null) {
                return `${this.getInsurerCodes[this.getSelectedInsurerCode]}Statement`;
            }

            return null;
        },
    },
    methods: {
        ...mapActions('contracting', ['contract']),
        async beforeHandleNext() {
            return new Promise(async (resolve, reject) => {
                this.$refs.form.validate().then(async success => {
                    if (success) {
                        const result = await this.$refs.dataComponent.beforeNext(this.getIsBusinessProcess);

                        this.isDisabled = !result.success;

                        if (result.success) {
                            this.loading = true;
                            const routeTo = await this.contract();
                            this.loading = false;
                            resolve(routeTo);
                        }
                    }
                });
            });
        },
        async beforeHandlePrev() {
            return new Promise(async (resolve, reject) => {
                resolve('contracting-summary');
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.con-1334 {
    padding-left: 0;
    padding-right: 0;
}

.navBtn-next {
    max-width: 220px;
}

.accordion-view {
    padding: 30px;

    @media only screen and (max-width: 1100px) {
        padding: 15px;
    }

    ul {
        display: flex;
        justify-content: flex-start;
        padding: 0;
        margin: 0;
        flex-wrap: wrap;
        list-style-type: none;

        @media only screen and (max-width: 1100px) {
            justify-content: flex-start;
        }

        li {
            width: 33%;
            padding: 7.5px;
            box-sizing: border-box;

            @media only screen and (max-width: 1100px) {
                width: 50% !important;
            }

            @media only screen and (max-width: 580px) {
                width: 100% !important;
            }

            span {
                display: inline-block;
                font-weight: 400;

                &:first-child {
                    font-weight: 700;
                }
            }
        }
    }

    .accordion-link {
        font-size: 16px;
        line-height: 24px;
        max-width: 250px;
        width: 100%;
        min-height: 48px;
        font-weight: 500;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #1068eb !important;
        color: #ffffff !important;
        transition: 0.2s !important;
        cursor: pointer;
        text-align: center;
        text-decoration: none;
        padding: 10px 15px;
    }
}

.error_text {
    text-align: center;
    margin-top: 1rem;
    color: red;
}

</style>
